import {AppState} from "../store";

export const getDispatchRequestPageFilter = (state: AppState) => state.dispatchRequestPage.filter
export const getDispatchRequestPageState = (state: AppState) => state.dispatchRequestPage.state
